import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMessageChange, 
        setItemProgress, 
        toggleSwitch } from '../../actions/index'

import { Button } from '@material-ui/core';

import { _ } from '../../functions/translator.js';
import { postData } from '../../functions/postData.js';
import { getItemsProgressData } from '../../functions/getData';
import { showMessage } from '../../functions/popUpMessage.js';
import { ToggleActions } from '../../constants/constants.js';

class ConfirmationAddProgress extends React.Component{

    handleClose = () => {
        this.props.popUpMessageChange({ show: false })
    }

    handleConfirm = async () => {
        const message = _('Editando avance') + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            item_id: this.props.item.id,
            progress: this.props.item.progress === '100.0%' ? this.props.item.previousProgress : 100,
            project_id: window.project_id
        }
        let response = await postData('/web-api/add-progress-update', urlPost)
        this.handleResponse(response)
    }

    handleResponse = (response) => {
        if (response.status === 'success') {
            showMessage(this.props, _('Avance editado exitosamente'));
            this.reloadProgress()
        } else {
            showMessage(this.props, _('Ocurrió un error al editar el avance'));
        }
    }

    async reloadProgress() {
        this.props.toggleSwitch(ToggleActions.LOADING_ITEMS)
        let itemsProgress = await getItemsProgressData(window.project_id)
        this.props.setItemProgress(itemsProgress)
        this.props.toggleSwitch(ToggleActions.LOADING_ITEMS)
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-around mt-4">
                    <Button variant="contained" className='confirm-cancel-button' onClick={ this.handleClose }>
                        { _('Cancelar') }
                    </Button>
                    <Button variant="contained" className='confirm-success-button' onClick={ this.handleConfirm }>
                        { _('Confirmar') }
                    </Button>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {}
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        popUpMessageChange : popUpMessageChange,
        setItemProgress : setItemProgress,
        toggleSwitch : toggleSwitch
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ConfirmationAddProgress)